import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { states } from "../states";
import classNames from "classnames";
import { getValueFromStringObjPath } from "@default/paragraphs/webform/webform-elements";

const CheckboxField = ({ item, small, compositeIndex, compositeParent }) => {
  const { values, handleChange, handleBlur } = useFormikContext();

  const { invisible, visible, enabled, disabled, optional, required } = states(
    item["#states"],
    values
  );

  const value = compositeParent
    ? typeof compositeIndex !== "undefined"
      ? getValueFromStringObjPath(values, compositeParent)[compositeIndex][
          item.id
        ]
      : getValueFromStringObjPath(values, compositeParent)[item.id]
    : values[item.id];
  const identifier = compositeParent
    ? typeof compositeIndex !== "undefined"
      ? `${compositeParent}[${compositeIndex}][${item.id}]`
      : `${compositeParent}[${item.id}]`
    : item.id;

  return (
    <div
      className={classNames({
        "form-group form-check boolean": true,
        smaller: !!small,
        hidden: invisible || !visible,
      })}
      style={item["#flex"] ? { flex: item["#flex"] } : {}}
    >
      <label htmlFor={item.id}>
        <Field
          className={classNames({
            "form-check-input boolean": true,
            smaller: !!small,
          })}
          type="checkbox"
          id={identifier}
          value={!!value}
          checked={!!value}
          name={identifier}
          onChange={handleChange}
          onBlur={handleBlur}
          required={(!!item["#required"] || required) && !optional && visible}
          disabled={!enabled || disabled || item["#disabled"]}
        />

        <span>{item["#title"]}</span>

        {(!!item["#required"] || required) && !optional && visible && (
          <span className="required">*</span>
        )}
      </label>

      <ErrorMessage
        role="region"
        aria-live="polite"
        component="span"
        name={item.id}
        className="error-message"
      />

      {!!item["#description"] && (
        <small
          className="form-description text-muted form-text"
          dangerouslySetInnerHTML={{ __html: item["#description"] }}
        />
      )}
    </div>
  );
};

CheckboxField.propTypes = {
  small: PropTypes.bool,
  compositeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  compositeParent: PropTypes.string,
  item: PropTypes.shape({
    "#default_value": PropTypes.string,
    "#description": PropTypes.string,
    "#flex": PropTypes.number,
    "#maxlength": PropTypes.number,
    "#minlength": PropTypes.number,
    "#placeholder": PropTypes.string,
    "#required": PropTypes.bool,
    "#required_error": PropTypes.string,
    "#states": PropTypes.object,
    "#submit__label": PropTypes.string,
    "#title": PropTypes.node,
    "#type": PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    "#disabled": PropTypes.bool,
  }),
};

export default CheckboxField;
